import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/AMEER HAMZA.png";  
import Tilt from "react-parallax-tilt";
import AbouteCertificateCard from "./AbouteCertificateCard";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
           <Col
            md={5}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "30px",
              paddingBottom: "30px",
            }}
            className="about-img circular-image"
          >
            <Tilt>
            <img
  src={laptopImg}
  alt="about"
  className="img-fluid rounded"
  style={{
    boxShadow: "0 0 15px 5px rgb(0, 0, 0)",
    transition: "box-shadow 0.3s ease-in-out",
    maxWidth: "80%",
    height: "auto",
  }}
/>

            </Tilt>
          </Col>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
            
          </Col>
         
          <AbouteCertificateCard/>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        
        <Techstack />
      </Container>
    </Container>
  );
}

export default About;
